import axios from 'axios'

const getBaseUrl = () => {
  const baseUrl = process.env.VUE_APP_LEAD_API_BASE_URI
  if (!baseUrl) {
    throw new Error(
      'The VUE_APP_LEAD_API_BASE_URI environment variable is required, but was not specified'
    )
  }
  return baseUrl
}
const getGuid = () => {
  const guid = process.env.VUE_APP_DEFAULT_GUID
  if (!guid) {
    throw new Error(
      'The VUE_APP_DEFAULT_GUID environment variable is required, but was not specified'
    )
  }
  return guid
}

const additionalParams = () => {
  return {
    pGUID: getGuid()
  }
}

export const post = (params) => {
  const fullParams = Object.assign(additionalParams(), params)
  return axios
    .post(getBaseUrl(), fullParams, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then(response => {
      return response
    })
    .catch(error => {
      return error
    })
}
